import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const PrivacyAndPolicyPage = () => {
    const privacyandpolicyPage = [
        {
            id: 1,
            policyTitle: "Use of Matrix Executive Search Group",
            policyRules: [
                {
                    id: 1,
                    policyInnerRule:
                        "At Matrix Executive Search Group, accessible at matrixexecutivesearch.com, your privacy is one of our top priorities. This Privacy Policy outlines the types of personal information we collect and how we use it at ",
                    bold: "Matrix Executive Search Group.",
                },
                {
                    id: 2,
                    policyInnerRule:
                        "If you have additional questions or require more information about our Privacy Policy, you may contact us at support@matrixexecutivesearch.com."
                },
                {
                    id: 3,
                    policyInnerRule:
                        "This Privacy Policy applies only to our online activities and is valid for visitors to our website regarding the information they share and/or collect at Matrix Executive Search Group. This policy does not apply to information collected offline or via other channels."
                },
                {
                    id: 4,
                    policyInnerRule:
                        "We are committed to protecting children online. We encourage parents and guardians to observe, participate in, and monitor their children’s online activity."
                }
            ]
        },
        {
            id: 2,
            policyTitle: "We use your information to:",
            policyRules: [
                {
                    id: 1,
                    policyInnerRule: "Connect job seekers with relevant job opportunities."
                },
                {
                    id: 2,
                    policyInnerRule:
                        "Enable employers to post job listings and manage candidate applications."
                },
                {
                    id: 3,
                    policyInnerRule:
                        "Improve user experience through personalized content and features."
                },
                {
                    id: 4,
                    policyInnerRule:
                        "Send notifications related to your job applications, saved jobs, or platform updates."
                }
            ]
        },
        {
            id: 3,
            policyTitle: "Privacy and Copyright Protection",
            policyRules: [
                {
                    id: 1,
                    policyInnerRule:
                        "All content, including job listings, graphics, logos, and text, is the intellectual property of Matrix Executive Search Group unless otherwise stated. Unauthorized use or reproduction is prohibited."
                },
                {
                    id: 2,
                    policyInnerRule:
                        "We ensure that user data is handled in compliance with applicable privacy laws and regulations. We do not sell or share your personal information with third parties without your consent."
                }
            ]
        }
    ];


    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        {privacyandpolicyPage.map((privacyandpolicyDetails, key) => (
                            <Col lg={12} key={key}>
                                <h5 className="mb-4">{privacyandpolicyDetails.policyTitle}</h5>
                                <ul className="about-list list-unstyled text-muted mb-4 pb-2">
                                    {privacyandpolicyDetails.policyRules.map(
                                        (privacyandpolicyInner, key) => (
                                            <li key={key}>{privacyandpolicyInner.policyInnerRule}<b className="text-danger">{privacyandpolicyInner.bold}</b></li>
                                        )
                                    )}
                                </ul>
                            </Col>
                        ))}
                        <div className="text-end">
                            <Link to="#" className="btn btn-primary" onClick={() => window.print()}>
                                <i className="uil uil-print"></i> &ensp; Print Privacy Policy
                            </Link>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default PrivacyAndPolicyPage;
